module.exports = __webpack_public_path__ + "img/windows.e7e06882.png";